import moment from "moment";

export function flot(params){

    var line_data = {
        data: params.data,
        color: '#3c8dbc'
    }

    $.plot('#chart', [line_data], {
        grid: {
            hoverable: true,
            borderColor: '#f3f3f3',
            borderWidth: 1,
            tickColor: '#f3f3f3'
        },
        series: {
            shadowSize: 0,
            lines: {
                show: true
            },
            points: {
                show: true
            }
        },
        lines: {
            fill: false,
            color: ['#3c8dbc']
        },
        yaxis: {
            show: true,
            minTickSize: 1,
            tickDecimals: 0,
        },
        xaxis : {
            show: true,
            mode: 'time',
            timeformat: "%d/%m",
            minTickSize: [1, "day"],
        }
    });

    //Initialize tooltip on hover
    $('<div class="tooltip-inner" id="chart-tooltip"></div>').css({
        position: 'absolute',
        display : 'none',
        opacity : 0.8
    }).appendTo('body');

    $('#chart').bind('plothover', function (event, pos, item) {

      if(item){

        var x = moment.unix(item.datapoint[0]).format("DD/MM/YY"),
            y = item.datapoint[1];

        $('#chart-tooltip')
            .html(x + ': ' + y)
            .css({
                top : item.pageY + 5,
                left: item.pageX + 5
            })
            .fadeIn(200);

      } else {
        $('#chart-tooltip').hide();
      }

    });

}